import { useState } from "react";
import { useNavigate } from "react-router-dom";
import DisplayAccessibility from "../../components/header/userMenu/DisplayAccessibility";

export default function DisplayAccessibilityPage() {
  const [, setVisible] = useState(0);
  const navigate = useNavigate();

  const handleGoBack = () => {
    navigate('/');
  };

  return (
    <div>
      <div className="go_back_button" onClick={handleGoBack}>
        <i className="arrow_back_icon"></i>
        <span>Go Back</span>
      </div>
      <div className="display_accessibility_page">
        <DisplayAccessibility setVisible={setVisible} />
      </div>
    </div>
  );
} 